// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"5c253a3d4a06b4b28d04","293":"41d953ddc6ad0973264b","518":"b27cbfa3bd0ee4078fd8","779":"a62c794c49661c79d3b6"}[chunkId] + ".js";
};